import styled from 'styled-components';

export const BrandPortfolioDesktopWrapper = styled.section`
  margin: 0px auto;
  position: relative;
  background-color: #f2f2f2;
  padding-top: 100px;
  padding-bottom: 100px;
  display: none;
  @media (max-width: 992px) {
    padding-top: 70px;
    padding-bottom: 70px;
  }
  @media (min-width: 768px) {
    display: block;
  }
`;
export const BrandPortfolioDesktopContainer = styled.div`
  max-width: 1696px;
  margin: 0px auto;
  position: relative;
`;
export const BrandPortfolioDesktopHeader = styled.div`
  text-align: center;
  h2 {
    color: #000;
    font-size: 30px;
    line-height: 30px;
    font-weight: 400;
    margin-bottom: 0px;
    @media (max-width: 1199px) {
      font-size: 26px;
      line-height: 30px;
      margin-bottom: 0px;
    }
    @media (max-width: 768px) {
      font-size: 20px;
      line-height: 30px;
      margin-bottom: 0;
    }
  }
`;
export const BrandPortfolioDesktopBody = styled.div`
  padding-top: 50px;
`;
export const BrandPortfolioDesktopTabs = styled.div`
  display: flex;
  justify-content: center;
`;
export const BrandPortfolioDesktopTab = styled.h5`
  font-size: 18px;
  color: #b4b4b4;
  line-height: 20px;
  font-weight: 500;
  text-transform: uppercase;
  margin: 0px;
  cursor: pointer;
  padding-right: 50px;
  padding-left: 50px;
  position: relative;
  @media (max-width: 1200px) {
    font-size: 15px;
    padding-right: 35px;
    padding-left: 35px;
  }
  @media (max-width: 992px) {
    font-size: 14px;
    padding-right: 30px;
    padding-left: 30px;
  }
  &.active-tab {
    color: #3b79d6;
  }
  &:before {
    content: '';
    position: absolute;
    background-color: #b4b4b4;
    height: 20px;
    width: 2px;
    right: 0%;
    top: 2px;
  }
  &[dir='ltr'] {
    &:last-child {
      &:before {
        content: '';
        display: none;
      }
    }
  }
  &[dir='rtl'] {
    &:first-child {
      &:before {
        content: '';
        display: none;
      }
    }
  }
`;
export const BrandPortfolioDesktopContent = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  gap: 23px;
  padding-top: 60px;
`;
export const BrandPortfolioDesktopCard = styled.div`
  width: 190px;
  height: 190px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  span {
    display: flex !important;
    justify-content: center;
    width: 100%;
    img {
      width: 80%;
      height: auto;
      object-fit: contain;
    }
  }
`;
export const BrandProtfolioModalWrapper = styled.button`
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: #f2f2f2b5;
  z-index: 100;
  outline: none;
  border: none;
`;
export const BrandProtfolioModal = styled.button`
  width: 770px;
  min-height: 510px;
  background-color: #fff;
  padding-top: 100px;
  padding-bottom: 100px;
  padding-left: 110px;
  padding-right: 125px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  outline: none;
  border: none;
  @media (max-width: 992px) {
    width: 95%;
    min-height: auto;
    padding-top: 30px;
    padding-bottom: 30px;
    padding-left: 35px;
    padding-right: 30px;
  }
`;
export const BrandProtfolioModalCloseButton = styled.button`
  outline: none;
  border: none;
  background: none;
  cursor: pointer;
  position: absolute;
  top: 20px;
  width: 16px;
  height: 16px;
  &[dir='rtl'] {
    left: 31px;
  }
  &[dir='ltr'] {
    right: 31px;
  }
  &:after {
    position: absolute;
    left: 15px;
    content: ' ';
    height: 20px;
    width: 2px;
    background-color: #b0b0b0;
    -webkit-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
  &:before {
    position: absolute;
    left: 15px;
    content: ' ';
    height: 20px;
    width: 2px;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
    background-color: #b0b0b0;
  }
  @media (max-width: 992px) {
    width: auto;
    height: auto;
  }
`;
export const BrandProtfolioModalLogo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px;
  span {
    display: flex !important;
    justify-content: center;
    align-items: center;
  }
  img {
    min-width: auto;
    height: auto;
    object-fit: contain;
    height: 150px;
    @media (max-width: 992px) {
      width: 60%;
      height: auto;
      height: auto;
      object-fit: contain;
    }
  }
`;
export const BrandPortfolioModalContent = styled.div`
  padding-top: 50px;
  text-align: center;
  h2 {
    font-size: 30px;
    margin: 0px;
    line-height: 30px;
    color: #4a4a4a;
    @media (max-width: 992px) {
      font-size: 20px;
      line-height: 30px;
    }
  }
  p {
    padding-top: 20px;
    font-size: 14px;
    line-height: 20px;
    color: #898989;
    margin-bottom: 0px;
    @media (max-width: 992px) {
      padding-top: 15px;
    }
    &[dir='ltr'] {
      font-family: DINRegular;
    }
    &[dir='rtl'] {
      font-family: GESSTwoDWTCLight, sans-serif;
    }
  }
  @media (max-width: 992px) {
    padding-top: 25px;
  }
`;
export const PrevButton = styled.button`
  outline: none;
  border: none;
  background: none;
  position: absolute;
  top: 50%;
  left: 26px;
  cursor: pointer;
  @media (max-width: 992px) {
    left: 5px;
    height: 30px;
    width: 30px;
    background: #e7e4e4;
    border-radius: 50%;
    svg {
      width: 8px;
      height: 27px;
    }
  }
`;
export const NextButton = styled.button`
  outline: none;
  border: none;
  background: none;
  position: absolute;
  top: 50%;
  right: 26px;
  cursor: pointer;
  @media (max-width: 992px) {
    right: 5px;
    height: 30px;
    width: 30px;
    background: #e7e4e4;
    border-radius: 50%;
    svg {
      width: 8px;
      height: 27px;
    }
  }
`;
export const BrandPortfolioMobileWrapper = styled.section`
  display: block;
  margin: 0px auto;
  position: relative;
  background-color: #f2f2f2;
  padding-top: 50px;
  padding-bottom: 50px;
  padding-left: 15px;
  padding-right: 15px;
  @media (min-width: 768px) {
    display: none;
  }
`;
export const BrandPortfolioMobileHeader = styled.div`
  text-align: center;
  h2 {
    color: #000;
    font-size: 14px;
    line-height: 14px;
    margin: 0px;
  }
`;
export const BrandPortfolioMobileBodyWrapper = styled.div`
  padding-top: 20px;
`;
export const BrandPortfolioMobileTabs = styled.div`
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
  .swiper {
    .swiper-wrapper {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      .swiper-slide {
        width: auto !important;
        height: auto;
        margin-right: 0px !important;
      }
    }
  }
`;
export const BrandPortfolioMobileTab = styled.div`
  margin: 0px;
  text-transform: uppercase;
  border: 1px solid #e6e6e6;
  background: var(--white, #fff);
  color: #4a4a4a;
  font-size: 11px;
  font-weight: 500;
  line-height: 1;
  text-align: center;
  font-weight: 500;
  cursor: pointer;
  padding: 8px 12px;
  &.active-tab {
    background-color: #3b79d6;
    color: #fff !important;
  }
`;
export const BrandPortfolioMobileCardContent = styled.div`
  padding-top: 30px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
`;
export const LoadMoreButton = styled.div`
  margin-top: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  button {
    cursor: pointer;
    display: inline-block;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    font-family: DINMediumAlternate;
    border: 1px solid transparent;
    line-height: 1.5;
    font-size: 12px;
    border-radius: 20px;
    -webkit-letter-spacing: 1.29px;
    -moz-letter-spacing: 1.29px;
    -ms-letter-spacing: 1.29px;
    letter-spacing: 1.29px;
    padding: 10px 1.5rem;
    min-width: 215px;
    text-align: center;
    text-transform: uppercase;
    background-color: #1b7bdd;
    -webkit-transition: 0.3s;
    transition: 0.3s;
    color: #fff;
  }
`;
export const BrandPortfolioMobileCardButton = styled.button`
  width: calc(33.3333% - 8px);
  height: 110px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  outline: none;
  border: none;
  span {
    display: flex !important;
    justify-content: center;
    width: 100%;
    img {
      width: 80%;
      height: auto;
      object-fit: contain;
    }
  }
`;
export const PrevTabButton = styled.button`
  outline: none;
  border: none;
  background: none;
  position: absolute;
  top: 18%;
  cursor: pointer;
  height: 35px;
  width: 35px;
  background: #e7e4e4;
  border-radius: 50%;
  z-index: 9;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 992px) {
    left: 0px;
    svg {
      width: 10px;
      height: 16px;
    }
  }
`;
export const NextTabButton = styled.div`
  outline: none;
  border: none;
  background: none;
  position: absolute;
  top: 18%;
  cursor: pointer;
  height: 35px;
  width: 35px;
  background: #e7e4e4;
  border-radius: 50%;
  z-index: 9;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 992px) {
    right: 0px;
    svg {
      width: 10px;
      height: 16px;
    }
  }
`;
